define('models/HybridRoutingCollection',['underscore','ObjectCollection','models/HybridRoutingModel'],function (_,ObjectCollection,HybridRoutingModel) {
    //
    // Collection HybridRouting
    //
    var HybridRoutingCollectionPrototype = {
        
        name:'HybridRoutingCollection',
        model:HybridRoutingModel,
        initialize:function(){
            // ObjectCollection constructor heritage
            var collection = this;
            ObjectCollection.prototype.initialize.apply(collection,arguments);
        },
        findByRoute:function(url,page,options){
            return this.find(function(hybridRoutingModel){
                return hybridRoutingModel.isRoute(url,page,options)
            })
        },
        usePageReload:function(url,page,options){
            var hybridRoutingModel = this.findByRoute(url,page,options);
            return !!hybridRoutingModel && hybridRoutingModel.usePageReload(url,page,options);
        }
    };

    var HybridRoutingCollection = ObjectCollection.extend(HybridRoutingCollectionPrototype);

    return HybridRoutingCollection;
});
